const ACTION = {
    UPDATE_USER_NAME: 'UPDATE_USER_NAME',
    UPDATE_USER_NAME_ERROR_TEXT: 'UPDATE_USER_NAME_ERROR_TEXT',
}

export default ACTION;